import { Routes, Route } from "react-router-dom";
import AccountList from "./AccountList";
import AccountForm from "./AccountForm";

export default function Account(){
  return (
    <div>
      <h2>Accounts</h2>
      <Routes>
        <Route path="/" element={<AccountList />} />
        <Route path="new" element={<AccountForm />} />
        <Route path="edit/:id" element={<AccountForm />} />
      </Routes>
    </div>
  );
}
